import React from "react";
import { useTheme } from "@material-ui/core";

import { Menu, MenuItem, Typography, ListSubheader, Grid } from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

import { ITypeNotification, PORTAL } from "./model/interface";

import { formatDateDistanceNow } from "@utils/index";
import { findLabelByValueOrLabelInFilialList } from "@utils/enum/filial";

export interface INotificationIntegration {
  id: string;
  title: string;
  message: string;
  read: boolean;
  sentAt: string;
  subsidiaryRef?: string;

  type?: ITypeNotification;
}

interface INotificationsProps {
  anchorEl: HTMLElement | null;
  handleCloseMenu: () => void;
  handleOpenModal: (notification) => void;
  handleOpenPortalModal: (uuid) => void;
  notifications: Array<INotificationIntegration>;
}

const Notifications: React.FC<INotificationsProps> = (props) => {
  const theme = useTheme();
  const rosa = theme.palette.primaryLight.main;
  const branco = theme.palette.background.paper;
  const vermelho = theme.palette.primary.main;

  const {
    anchorEl,
    handleCloseMenu,
    notifications,
    handleOpenModal,
    handleOpenPortalModal,
  } = props;

  return (
    <Menu
      id="positioned-menu"
      aria-labelledby="positioned-button"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleCloseMenu}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      elevation={0}
      slotProps={{
        paper: {
          sx: {
            width: { xs: "300px", md: "400px" },
            maxWidth: { xs: "300px", md: "500px" },
            marginTop: { xs: 2, md: 4 },
          },
        },
      }}
    >
      <ListSubheader>
        <Typography variant="h5" sx={{ fontWeight: 700, pb: 1.4 }}>
          Notificações
        </Typography>
      </ListSubheader>

      {notifications?.map((row) => {
        const { id, title, message, read, sentAt, subsidiaryRef, type } = row;

        const subRef = subsidiaryRef?.split(",");
        const filial = subRef
          ?.map(
            (item) => findLabelByValueOrLabelInFilialList(item)?.label ?? ""
          )
          .filter((item) => !!item)
          .join(", ");

        return (
          <MenuItem
            key={id}
            onClick={() =>
              type === PORTAL ? handleOpenPortalModal(id) : handleOpenModal(row)
            }
          >
            <Grid
              container
              sx={{
                gap: 1,
                border: "1px solid rgba(0,0,0,0.1)",
                borderRadius: 1,
                p: 1,
                background: read ? branco : rosa,
              }}
            >
              <Grid item xs={10.8}>
                <Grid container sx={{ gap: 0.8 }}>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      gap: 1,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <WarningAmberOutlinedIcon
                      sx={{
                        fontSize: 16,
                        color: read ? vermelho : branco,
                        background: read ? rosa : vermelho,
                        borderRadius: 4,
                        width: "22px",
                        height: "22px",
                        padding: "5px",
                      }}
                    />

                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        textOverflow: "ellipsis",
                        overflowX: "hidden",
                      }}
                    >
                      {title}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="body1"
                      sx={{
                        textOverflow: "ellipsis",
                        overflowX: "hidden",
                      }}
                    >
                      {message}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    sx={{
                      whiteSpace: "break-spaces",
                      lineHeight: 0,
                      textAlign: "justify",
                    }}
                  >
                    <Typography variant="caption">
                      {formatDateDistanceNow(sentAt)} -{" "}
                      <b style={{ paddingLeft: 1 }}>Filial </b> {filial}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        position: "absolute",
                        bottom: 5,
                        right: 20,
                        opacity: 0.5,
                      }}
                    >
                      {type === PORTAL ? "Portal" : ""}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={1} />
            </Grid>
          </MenuItem>
        );
      })}
    </Menu>
  );
};

export default Notifications;
